export default __webpack_public_path__ + "static/media/010_home.av1.b1a35877.mp4";